module.exports = __webpack_public_path__ + "static/img/4.2e4043f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/7/zh/4.png
// module id = cuPT
// module chunks = 0